import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { brand } from '../mock';

const Logo = ({ size = 34 }) => (
  <div
    className="flex items-center justify-center rounded-md"
    style={{ width: size, height: size }}
  >
    <svg viewBox="0 0 48 48" width={size} height={size} fill="none">
      <defs>
        <linearGradient id="navlogo" x1="0" y1="0" x2="48" y2="48">
          <stop offset="0" stopColor="#f3d98a" />
          <stop offset="1" stopColor="#c99a2e" />
        </linearGradient>
      </defs>
      <path d="M8 30c6-2 9-8 14-8 4 0 5 4 9 4 4 0 6-4 9-9" stroke="url(#navlogo)" strokeWidth="2.4" strokeLinecap="round" />
      <path d="M6 24c4 0 6 3 9 3" stroke="url(#navlogo)" strokeWidth="2" strokeLinecap="round" opacity="0.55" />
      <text x="12" y="22" fontFamily="Playfair Display, serif" fontSize="13" fontStyle="italic" fill="url(#navlogo)">rw</text>
    </svg>
  </div>
);

const Navbar = ({ onSignIn }) => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#0a0a0f]/90 backdrop-blur-md border-b border-[#1c1c24]' : 'bg-transparent border-b border-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 h-[68px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <div className="h-9 w-9 rounded-md bg-[#111119] flex items-center justify-center border border-[#26262f]">
            <Logo size={26} />
          </div>
          <div className="leading-none">
            <div className="flex items-baseline gap-1.5">
              <span className="font-serif-display text-[19px] text-[#d9d9de]">{brand.name}</span>
              <span className="text-[#3a3a45]">|</span>
              <span className="text-[18px] font-bold tracking-wide text-white">{brand.sub}</span>
            </div>
            <div className="text-[9px] tracking-[0.22em] text-[#c99a2e] font-semibold mt-0.5">
              {brand.tagline}
            </div>
          </div>
        </Link>
        <div className="flex items-center gap-6">
          <Link to="/blog" className="hidden sm:inline text-[13px] font-medium text-[#b8b8c0] hover:text-[#c99a2e] transition-colors">
            Blog
          </Link>
          <button
            onClick={onSignIn}
            className="px-5 py-2 rounded-lg bg-gradient-to-b from-[#e8c766] to-[#d4af37] text-[#1a1500] text-sm font-semibold hover:from-[#f0d27a] hover:to-[#e0b84c] transition-all shadow-[0_4px_16px_-4px_rgba(212,175,55,0.5)]"
          >
            Sign In
          </button>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
